/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class PaymentService extends HttpHandlerService {

        constructor($http: ng.IHttpService)
        {
            super($http);
        }

        public getPaymentRequestDetails(processId: string, paymentConfigId: string): ng.IPromise<Wars.Domain.Model.Dtos.Payments.PaymentRequestDto> {
            var params: any = {};
            this.handlerUrl = "api/Payment/RequestDetails/" + processId + "/" + paymentConfigId;
            return this.useGetHandler(params).then(
                (result: Wars.Domain.Model.Dtos.Payments.PaymentRequestDto) => {
                    return result;
                });
        }
    }
}

warsApp.registerService("PaymentService", ["$http"]);